import request from '../../utils/request';

const getAuth = (payload) =>
  request({
    url: '/auth',
    method: 'POST',
    data: {
      ...payload,
    },
  });

const validateCode = (payload) =>
  request({
    url: '/validate',
    method: 'POST',
    data: {
      ...payload,
    },
  });

const AuthService = {
  getAuth,
  validateCode,
};

export default AuthService;
